import { lazy } from 'react';

export const TeacherLessonPage = lazy(() => import('./TeacherLessonPage'));
